import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { transformationLines } from '../data/content';
export function TransformationSection() {
  return <section className="w-full bg-shell py-20 md:py-28" aria-labelledby="transformacion" data-id="element-236" data-mp="2wxduyx1oahpd">
      <div className="mx-auto max-w-3xl px-6 lg:px-8" data-id="element-237" data-mp="2ryt25ior30ay">
        <SectionHeading eyebrow="Imagina" title={<span id="transformacion" data-id="element-239" data-mp="2nwz6xpxbqoi6">Imagina cómo podrías sentirte después de comenzar…</span>} data-id="element-238" data-mp="2ry18weimlenu" />

        <ul className="mt-14 space-y-6" data-id="element-240" data-mp="2j690e9d5wflw">
          {transformationLines.map((line, i) => <Reveal key={line} delay={i * 0.08} data-id="element-241" data-mp="2j460mxm7j83z" data-mpi={i}>
              <li className="flex items-start gap-5" data-id="element-242" data-mp="2e6crpwtis000">
                <span aria-hidden="true" className="mt-4 block h-[1px] w-8 shrink-0 bg-goldsoft sm:w-12" data-id="element-243" data-mp="2e4tc88fotsza" />
                <span className="font-display text-[1.6rem] font-light leading-snug text-ink sm:text-3xl" data-id="element-244" data-mp="248yq33c99frr">
                  {line}
                </span>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}